import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Alert, Badge, Button, Card, Form, Modal, Spinner, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import QRCode from "qrcode";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { productCheckApi } from "services/productCheck.service";
import { DobybotSocketClient } from "services/dobybot/DobybotSocketClient";
var requestId = function() {
    var _window_crypto_randomUUID, _window_crypto;
    return ((_window_crypto = window.crypto) === null || _window_crypto === void 0 ? void 0 : (_window_crypto_randomUUID = _window_crypto.randomUUID) === null || _window_crypto_randomUUID === void 0 ? void 0 : _window_crypto_randomUUID.call(_window_crypto)) || "".concat(Date.now(), "-").concat(Math.random().toString(16).slice(2));
};
var getErrorMessage = function(error) {
    var _error_response_data, _error_response;
    var _error_response_data_message;
    var message = (_error_response_data_message = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) !== null && _error_response_data_message !== void 0 ? _error_response_data_message : error === null || error === void 0 ? void 0 : error.message;
    var rawMessage = Array.isArray(message) ? message.join("\n") : typeof message === "object" ? message === null || message === void 0 ? void 0 : message.message : message;
    if (!rawMessage) return "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
    if (/[\u0E00-\u0E7F]/.test(rawMessage)) return rawMessage;
    return "เกิดข้อผิดพลาดในการตรวจสอบสินค้า กรุณาลองใหม่อีกครั้ง";
};
export function ProductCheck() {
    var reportId = useParams().reportId;
    var navigate = useNavigate();
    var scannerRef = useRef(null);
    var lockTokenRef = useRef("");
    var dobybotRef = useRef(null);
    var busyRef = useRef(false);
    var loaderTimerRef = useRef(null);
    var barcodeItemIndexesRef = useRef(new Map());
    var qrCodeBarcodesRef = useRef({});
    var qrCodeDataUrlCacheRef = useRef(new Map());
    var _useState = _sliced_to_array(useState(null), 2), session = _useState[0], setSession = _useState[1];
    var _useState1 = _sliced_to_array(useState(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), busy = _useState2[0], setBusy = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), loaderVisible = _useState3[0], setLoaderVisible = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), error = _useState4[0], setError = _useState4[1];
    var _useState5 = _sliced_to_array(useState("กำลังเชื่อมต่อ"), 2), socketStatus = _useState5[0], setSocketStatus = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), isDobybotConnected = _useState6[0], setIsDobybotConnected = _useState6[1];
    var _useState7 = _sliced_to_array(useState({}), 2), qrCodes = _useState7[0], setQrCodes = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        id: 0,
        show: false,
        message: "",
        variant: "success"
    }), 2), toast = _useState8[0], setToast = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        show: false,
        title: "",
        message: ""
    }), 2), scanAlert = _useState9[0], setScanAlert = _useState9[1];
    var focusScanner = useCallback(function() {
        window.setTimeout(function() {
            var _scannerRef_current;
            return (_scannerRef_current = scannerRef.current) === null || _scannerRef_current === void 0 ? void 0 : _scannerRef_current.focus();
        }, 0);
    }, []);
    var beginBusy = useCallback(function() {
        if (busyRef.current) return false;
        busyRef.current = true;
        setBusy(true);
        return true;
    }, []);
    var endBusy = useCallback(function() {
        busyRef.current = false;
        setBusy(false);
    }, []);
    useEffect(function() {
        window.clearTimeout(loaderTimerRef.current);
        if (busy) {
            loaderTimerRef.current = window.setTimeout(function() {
                setLoaderVisible(true);
            }, 120);
        } else {
            setLoaderVisible(false);
        }
        return function() {
            return window.clearTimeout(loaderTimerRef.current);
        };
    }, [
        busy
    ]);
    var showToast = function(message) {
        var variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "success";
        setToast({
            id: Date.now(),
            show: true,
            message: message,
            variant: variant
        });
    };
    var showScanAlert = function(title, message) {
        setScanAlert({
            show: true,
            title: title,
            message: message
        });
    };
    var updateLocalQuantity = useCallback(function(detailId, quantity) {
        setSession(function(current) {
            return _object_spread_props(_object_spread({}, current), {
                items: current.items.map(function(item) {
                    return item.product_check_item_detailid === detailId ? _object_spread_props(_object_spread({}, item), {
                        product_check_item_scannedqty: quantity
                    }) : item;
                })
            });
        });
    }, []);
    var indexSessionItems = useCallback(function() {
        var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var barcodeIndexes = new Map();
        items.forEach(function(item, index) {
            var barcode = String(item.product_check_item_barcode || "").trim();
            if (!barcode) return;
            var indexes = barcodeIndexes.get(barcode) || [];
            indexes.push(index);
            barcodeIndexes.set(barcode, indexes);
        });
        barcodeItemIndexesRef.current = barcodeIndexes;
    }, []);
    useEffect(function() {
        var active = true;
        var acquire = function() {
            var _ref = _async_to_generator(function() {
                var data, client, ping, e, acquireError;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                productCheckApi.acquire(reportId)
                            ];
                        case 1:
                            data = _state.sent();
                            if (!active) return [
                                2
                            ];
                            lockTokenRef.current = data.lockToken;
                            indexSessionItems(data.items);
                            setSession(data);
                            setLoading(false);
                            focusScanner();
                            client = new DobybotSocketClient();
                            dobybotRef.current = client;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                client.connect()
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                client.ping()
                            ];
                        case 4:
                            ping = _state.sent();
                            if (active) {
                                setIsDobybotConnected(Boolean(ping.success));
                                setSocketStatus(ping.success ? "เชื่อมต่อแล้ว" : "ไม่ได้เชื่อมต่อ");
                            }
                            return [
                                3,
                                6
                            ];
                        case 5:
                            e = _state.sent();
                            if (active) {
                                setIsDobybotConnected(false);
                                setSocketStatus("ไม่ได้เชื่อมต่อ");
                            }
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            acquireError = _state.sent();
                            if (!active) return [
                                2
                            ];
                            setError(getErrorMessage(acquireError));
                            setLoading(false);
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function acquire() {
                return _ref.apply(this, arguments);
            };
        }();
        acquire();
        return function() {
            var _dobybotRef_current;
            active = false;
            (_dobybotRef_current = dobybotRef.current) === null || _dobybotRef_current === void 0 ? void 0 : _dobybotRef_current.close();
            var token = lockTokenRef.current;
            lockTokenRef.current = "";
            if (token) productCheckApi.release(reportId, token).catch(function() {
                return undefined;
            });
        };
    }, [
        focusScanner,
        indexSessionItems,
        reportId
    ]);
    useEffect(function() {
        if (!(session === null || session === void 0 ? void 0 : session.heartbeatSeconds) || !lockTokenRef.current) return undefined;
        var active = true;
        var renewing = false;
        var renewLock = function() {
            var _ref = _async_to_generator(function() {
                var heartbeatError, _heartbeatError_response, status;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!active || renewing || !lockTokenRef.current) return [
                                2
                            ];
                            renewing = true;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                productCheckApi.heartbeat(reportId, lockTokenRef.current)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            heartbeatError = _state.sent();
                            status = heartbeatError === null || heartbeatError === void 0 ? void 0 : (_heartbeatError_response = heartbeatError.response) === null || _heartbeatError_response === void 0 ? void 0 : _heartbeatError_response.status;
                            if (active && [
                                401,
                                403,
                                409
                            ].includes(status)) {
                                setError(getErrorMessage(heartbeatError));
                            }
                            return [
                                3,
                                5
                            ];
                        case 4:
                            renewing = false;
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function renewLock() {
                return _ref.apply(this, arguments);
            };
        }();
        var renewWhenActive = function() {
            if (document.visibilityState === "visible") renewLock();
        };
        var timer = window.setInterval(renewLock, session.heartbeatSeconds * 1000);
        window.addEventListener("focus", renewWhenActive);
        document.addEventListener("visibilitychange", renewWhenActive);
        return function() {
            active = false;
            window.clearInterval(timer);
            window.removeEventListener("focus", renewWhenActive);
            document.removeEventListener("visibilitychange", renewWhenActive);
        };
    }, [
        reportId,
        session === null || session === void 0 ? void 0 : session.heartbeatSeconds
    ]);
    useEffect(function() {
        var active = true;
        var createQrCodes = function() {
            var _ref = _async_to_generator(function() {
                var items, changedItems, entries;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            items = (session === null || session === void 0 ? void 0 : session.items) || [];
                            changedItems = items.filter(function(item) {
                                var detailId = item.product_check_item_detailid;
                                var barcode = item.product_check_item_barcode || "";
                                return qrCodeBarcodesRef.current[detailId] !== barcode;
                            });
                            if (changedItems.length === 0) return [
                                2
                            ];
                            return [
                                4,
                                Promise.all(changedItems.map(function() {
                                    var _ref = _async_to_generator(function(item) {
                                        var barcode, dataUrl, qrCodePromise;
                                        return _ts_generator(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    barcode = item.product_check_item_barcode || "";
                                                    dataUrl = "";
                                                    if (!barcode) return [
                                                        3,
                                                        2
                                                    ];
                                                    qrCodePromise = qrCodeDataUrlCacheRef.current.get(barcode);
                                                    if (!qrCodePromise) {
                                                        qrCodePromise = QRCode.toDataURL(barcode, {
                                                            margin: 1,
                                                            width: 76
                                                        });
                                                        qrCodeDataUrlCacheRef.current.set(barcode, qrCodePromise);
                                                    }
                                                    return [
                                                        4,
                                                        qrCodePromise
                                                    ];
                                                case 1:
                                                    dataUrl = _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2,
                                                        [
                                                            item.product_check_item_detailid,
                                                            dataUrl,
                                                            barcode
                                                        ]
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            entries = _state.sent();
                            if (!active) return [
                                2
                            ];
                            setQrCodes(function(current) {
                                return _object_spread({}, current, Object.fromEntries(entries.map(function(param) {
                                    var _param = _sliced_to_array(param, 2), detailId = _param[0], dataUrl = _param[1];
                                    return [
                                        detailId,
                                        dataUrl
                                    ];
                                })));
                            });
                            qrCodeBarcodesRef.current = _object_spread({}, qrCodeBarcodesRef.current, Object.fromEntries(entries.map(function(param) {
                                var _param = _sliced_to_array(param, 3), detailId = _param[0], barcode = _param[2];
                                return [
                                    detailId,
                                    barcode
                                ];
                            })));
                            return [
                                2
                            ];
                    }
                });
            });
            return function createQrCodes() {
                return _ref.apply(this, arguments);
            };
        }();
        createQrCodes();
        return function() {
            active = false;
        };
    }, [
        session === null || session === void 0 ? void 0 : session.items
    ]);
    var totals = useMemo(function() {
        return ((session === null || session === void 0 ? void 0 : session.items) || []).reduce(function(result, item) {
            return {
                expected: result.expected + item.product_check_item_expectedqty,
                scanned: result.scanned + item.product_check_item_scannedqty
            };
        }, {
            expected: 0,
            scanned: 0
        });
    }, [
        session === null || session === void 0 ? void 0 : session.items
    ]);
    var isComplete = totals.expected > 0 && totals.expected === totals.scanned;
    var productItemGroups = useMemo(function() {
        var visibleItems = ((session === null || session === void 0 ? void 0 : session.items) || []).filter(function(item) {
            return item.product_check_item_expectedqty > 0;
        });
        var completedItems = visibleItems.filter(function(item) {
            return item.product_check_item_scannedqty >= item.product_check_item_expectedqty;
        });
        var incompleteItems = visibleItems.filter(function(item) {
            return item.product_check_item_scannedqty < item.product_check_item_expectedqty;
        });
        return [
            {
                key: "incomplete",
                title: "รายการที่จำนวนยังไม่ครบ",
                items: incompleteItems,
                tableClassName: "",
                emptyMessage: "ไม่มีรายการที่จำนวนยังไม่ครบ"
            },
            {
                key: "completed",
                title: "รายการที่จำนวนครบแล้ว",
                items: completedItems,
                tableClassName: "product-check-table-completed",
                emptyMessage: "ยังไม่มีรายการที่จำนวนครบแล้ว"
            }
        ];
    }, [
        session === null || session === void 0 ? void 0 : session.items
    ]);
    var changeQuantity = function() {
        var _ref = _async_to_generator(function(item, quantityChange) {
            var source, _dobybotRef_current, result, updatedItem, remarkAction, itemBarcode, remarkMessage, actionText, quantitySuccessMessage, remarkResponse, _tmp, quantityError, message;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        source = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "MANUAL";
                        if (!lockTokenRef.current || !beginBusy()) return [
                            2
                        ];
                        setError("");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        return [
                            4,
                            productCheckApi.updateQuantity(reportId, lockTokenRef.current, {
                                requestId: requestId(),
                                detailId: item.product_check_item_detailid,
                                barcode: source === "BARCODE" ? item.product_check_item_barcode : undefined,
                                quantityChange: quantityChange,
                                source: source
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        updateLocalQuantity(result.detailId || item.product_check_item_detailid, result.scannedQuantity);
                        updatedItem = session.items.find(function(sessionItem) {
                            return sessionItem.product_check_item_detailid === result.detailId;
                        }) || item;
                        remarkAction = source === "BARCODE" ? "scan" : quantityChange > 0 ? "add" : "remove";
                        itemBarcode = String(updatedItem.product_check_item_barcode || "").trim();
                        remarkMessage = "".concat(itemBarcode, "_").concat(remarkAction);
                        actionText = source === "BARCODE" ? "สแกนเพิ่ม" : quantityChange > 0 ? "เพิ่ม" : "ลด";
                        quantitySuccessMessage = "".concat(actionText, " ").concat(updatedItem.name, " จำนวน 1 ").concat(updatedItem.unitName || "ชิ้น", " สำเร็จ");
                        if (!isDobybotConnected) {
                            showToast(quantitySuccessMessage, quantityChange > 0 ? "success" : "warning");
                            return [
                                2
                            ];
                        }
                        if (!(itemBarcode && remarkMessage.length <= 255)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (_dobybotRef_current = dobybotRef.current) === null || _dobybotRef_current === void 0 ? void 0 : _dobybotRef_current.remark(remarkMessage)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        _tmp = {
                            success: false,
                            msg: "ข้อความ Remark ยาวเกินกว่าที่กำหนด"
                        };
                        _state.label = 5;
                    case 5:
                        remarkResponse = _tmp;
                        if (remarkResponse === null || remarkResponse === void 0 ? void 0 : remarkResponse.success) {
                            showToast(quantitySuccessMessage, quantityChange > 0 ? "success" : "warning");
                        } else {
                            setIsDobybotConnected(false);
                            setSocketStatus("ไม่ได้เชื่อมต่อ");
                            showToast(quantitySuccessMessage, quantityChange > 0 ? "success" : "warning");
                        }
                        return [
                            3,
                            8
                        ];
                    case 6:
                        quantityError = _state.sent();
                        message = getErrorMessage(quantityError);
                        if (source === "BARCODE" && (message.includes("already completely checked") || message.includes("outside the allowed range") || message.includes("ตรวจนับครบตามจำนวนส่งจริง") || message.includes("จำนวนตรวจนับอยู่นอกช่วง"))) {
                            showScanAlert("จำนวนสินค้าเกิน", "สินค้าบาร์โค้ด ".concat(item.product_check_item_barcode, " ตรวจนับครบตามจำนวนสินค้าส่งจริงแล้ว ไม่สามารถเพิ่มจำนวนได้"));
                        } else {
                            setError(message);
                        }
                        return [
                            3,
                            8
                        ];
                    case 7:
                        endBusy();
                        focusScanner();
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function changeQuantity(item, quantityChange) {
            return _ref.apply(this, arguments);
        };
    }();
    var sendVideoCommand = function() {
        var _ref = _async_to_generator(function(command) {
            var client, message, commandRequestId, response, _tmp, _tmp1, videoActionText, videoError, message1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (busyRef.current) return [
                            2
                        ];
                        client = dobybotRef.current;
                        if (!isDobybotConnected || !client) {
                            showToast("ไม่ได้เชื่อมต่อ Dobybot ระบบจะทำงานต่อโดยไม่มีวิดีโอ", "warning");
                            focusScanner();
                            return [
                                2
                            ];
                        }
                        if (command === "stop" && !isComplete) {
                            message = "กรุณาตรวจนับสินค้าให้ครบก่อนหยุดบันทึกวิดีโอ";
                            setError(message);
                            showToast(message, "warning");
                            focusScanner();
                            return [
                                2
                            ];
                        }
                        if (!beginBusy()) return [
                            2
                        ];
                        setError("");
                        commandRequestId = requestId();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            12,
                            13,
                            14
                        ]);
                        if (!(command === "start")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            client.startRecord(session.reservation.rs_reserve_code)
                        ];
                    case 2:
                        _tmp = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 3:
                        if (!(command === "stop")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            client.stopRecord()
                        ];
                    case 4:
                        _tmp1 = _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            client.cancelRecord()
                        ];
                    case 6:
                        _tmp1 = _state.sent();
                        _state.label = 7;
                    case 7:
                        _tmp = _tmp1;
                        _state.label = 8;
                    case 8:
                        response = _tmp;
                        if (!!response.success) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            productCheckApi.videoResult(reportId, lockTokenRef.current, {
                                requestId: commandRequestId,
                                success: false,
                                command: command,
                                errorCode: response.error,
                                message: response.msg
                            }).catch(function() {
                                return undefined;
                            })
                        ];
                    case 9:
                        _state.sent();
                        throw new Error("Dobybot Desktop App ไม่ตอบกลับ กรุณาตรวจสอบว่าโปรแกรมกำลังทำงานอยู่");
                    case 10:
                        return [
                            4,
                            productCheckApi.videoResult(reportId, lockTokenRef.current, {
                                requestId: commandRequestId,
                                success: true,
                                command: command
                            })
                        ];
                    case 11:
                        _state.sent();
                        setSession(function(current) {
                            return _object_spread_props(_object_spread({}, current), {
                                videoState: command === "start" ? "RECORDING" : command === "stop" ? "STOPPED" : "CANCELLED"
                            });
                        });
                        videoActionText = {
                            start: "เริ่มบันทึกวิดีโอสำเร็จ",
                            stop: "หยุดบันทึกวิดีโอสำเร็จ",
                            cancel: "ยกเลิกการบันทึกวิดีโอสำเร็จ"
                        };
                        showToast(videoActionText[command], command === "cancel" ? "warning" : "success");
                        return [
                            3,
                            14
                        ];
                    case 12:
                        videoError = _state.sent();
                        setIsDobybotConnected(false);
                        setSocketStatus("ไม่ได้เชื่อมต่อ");
                        message1 = getErrorMessage(videoError);
                        setError(message1);
                        showToast("ดำเนินการวิดีโอไม่สำเร็จ: ".concat(message1), "danger");
                        return [
                            3,
                            14
                        ];
                    case 13:
                        endBusy();
                        focusScanner();
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendVideoCommand(command) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleScan = function() {
        var _ref = _async_to_generator(function(event) {
            var _scannerRef_current, _session_reservation, value, matchedItems, item, isFullyScanned;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        value = String(((_scannerRef_current = scannerRef.current) === null || _scannerRef_current === void 0 ? void 0 : _scannerRef_current.value) || "").trim();
                        if (scannerRef.current) scannerRef.current.value = "";
                        if (!value || busyRef.current) return [
                            2
                        ];
                        if (!(value === (session === null || session === void 0 ? void 0 : (_session_reservation = session.reservation) === null || _session_reservation === void 0 ? void 0 : _session_reservation.rs_reserve_code))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            sendVideoCommand(session.videoState === "RECORDING" ? "stop" : "start")
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        matchedItems = (barcodeItemIndexesRef.current.get(value) || []).map(function(index) {
                            return session.items[index];
                        }).filter(Boolean);
                        if (matchedItems.length === 0) {
                            showScanAlert("ไม่พบบาร์โค้ด", "บาร์โค้ด ".concat(value, " ไม่ตรงกับบาร์โค้ดสินค้าในใบจองนี้ และไม่ตรงกับรหัสใบจอง กรุณาตรวจสอบแล้วสแกนใหม่"));
                            return [
                                2
                            ];
                        }
                        item = matchedItems.find(function(matchedItem) {
                            return matchedItem.product_check_item_scannedqty < matchedItem.product_check_item_expectedqty;
                        }) || matchedItems[0];
                        isFullyScanned = matchedItems.every(function(matchedItem) {
                            return matchedItem.product_check_item_scannedqty >= matchedItem.product_check_item_expectedqty;
                        });
                        if (isFullyScanned) {
                            showScanAlert("จำนวนสินค้าเกิน", "สินค้าบาร์โค้ด ".concat(value, " ตรวจนับครบตามจำนวนสินค้าส่งจริงแล้ว ไม่สามารถเพิ่มจำนวนได้"));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            changeQuantity(item, 1, "BARCODE")
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScan(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var finish = function() {
        var _ref = _async_to_generator(function() {
            var finishError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isComplete || !beginBusy()) return [
                            2
                        ];
                        setError("");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!(!isDobybotConnected && session.videoState === "RECORDING")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            productCheckApi.videoResult(reportId, lockTokenRef.current, {
                                requestId: requestId(),
                                success: true,
                                command: "cancel",
                                source: "MANUAL",
                                message: "ยกเลิกสถานะบันทึกวิดีโอเนื่องจากไม่ได้เชื่อมต่อ Dobybot"
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            productCheckApi.complete(reportId, lockTokenRef.current)
                        ];
                    case 4:
                        _state.sent();
                        lockTokenRef.current = "";
                        navigate("/report/reservation", {
                            replace: true
                        });
                        return [
                            3,
                            6
                        ];
                    case 5:
                        finishError = _state.sent();
                        setError(getErrorMessage(finishError));
                        endBusy();
                        focusScanner();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function finish() {
            return _ref.apply(this, arguments);
        };
    }();
    var cancelProductCheck = function() {
        var _ref = _async_to_generator(function() {
            var token, cancelError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (busyRef.current || isDobybotConnected && session.videoState === "RECORDING") {
                            return [
                                2
                            ];
                        }
                        token = lockTokenRef.current;
                        if (!beginBusy()) return [
                            2
                        ];
                        setError("");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!token) return [
                            3,
                            5
                        ];
                        if (!(!isDobybotConnected && session.videoState === "RECORDING")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            productCheckApi.videoResult(reportId, token, {
                                requestId: requestId(),
                                success: true,
                                command: "cancel",
                                source: "MANUAL",
                                message: "ยกเลิกสถานะบันทึกวิดีโอเนื่องจากไม่ได้เชื่อมต่อ Dobybot"
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            productCheckApi.release(reportId, token)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        lockTokenRef.current = "";
                        navigate("/report/reservation");
                        return [
                            3,
                            7
                        ];
                    case 6:
                        cancelError = _state.sent();
                        setError(getErrorMessage(cancelError));
                        endBusy();
                        focusScanner();
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function cancelProductCheck() {
            return _ref.apply(this, arguments);
        };
    }();
    if (loading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "d-flex justify-content-center align-items-center py-5",
            children: /*#__PURE__*/ _jsx(Spinner, {
                animation: "border"
            })
        });
    }
    if (!session) {
        return /*#__PURE__*/ _jsxs(Card, {
            className: "m-4 p-4",
            children: [
                /*#__PURE__*/ _jsx(Alert, {
                    variant: "danger",
                    children: error
                }),
                /*#__PURE__*/ _jsx(Button, {
                    onClick: function() {
                        return navigate("/report/reservation");
                    },
                    children: "กลับหน้ารายงานการจอง"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "product-check-page",
        "aria-busy": busy,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "product-check-loader ".concat(loaderVisible ? "show" : ""),
                role: loaderVisible ? "status" : undefined,
                "aria-live": "polite",
                "aria-hidden": !loaderVisible,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "product-check-loader-panel",
                    children: [
                        /*#__PURE__*/ _jsx(Spinner, {
                            animation: "border",
                            variant: "primary"
                        }),
                        /*#__PURE__*/ _jsx("strong", {
                            children: "กำลังประมวลผล"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: "กรุณารอสักครู่..."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ToastContainer, {
                className: "position-fixed top-0 end-0 p-3",
                style: {
                    zIndex: 2000
                },
                children: /*#__PURE__*/ _jsxs(Toast, {
                    show: toast.show,
                    bg: toast.variant,
                    autohide: true,
                    delay: 1800,
                    onClose: function() {
                        return setToast(function(current) {
                            return _object_spread_props(_object_spread({}, current), {
                                show: false
                            });
                        });
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Toast.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ _jsx("strong", {
                                className: "me-auto",
                                children: "ตรวจสอบสินค้า"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Toast.Body, {
                            className: [
                                "success",
                                "danger"
                            ].includes(toast.variant) ? "text-white" : "",
                            children: toast.message
                        })
                    ]
                }, toast.id)
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: scanAlert.show,
                centered: true,
                backdrop: "static",
                keyboard: false,
                onHide: function() {
                    return setScanAlert(function(current) {
                        return _object_spread_props(_object_spread({}, current), {
                            show: false
                        });
                    });
                },
                onExited: focusScanner,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            className: "text-danger",
                            children: scanAlert.title
                        })
                    }),
                    /*#__PURE__*/ _jsx(Modal.Body, {
                        className: "fs-18",
                        children: scanAlert.message
                    }),
                    /*#__PURE__*/ _jsx(Modal.Footer, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "primary",
                            onClick: function() {
                                return setScanAlert(function(current) {
                                    return _object_spread_props(_object_spread({}, current), {
                                        show: false
                                    });
                                });
                            },
                            children: "ตกลง"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "product-check-header",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex align-items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Inventory2OutlinedIcon, {}),
                            /*#__PURE__*/ _jsx("strong", {
                                children: "ตรวจสอบสินค้า"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        disabled: busy || isDobybotConnected && session.videoState === "RECORDING",
                        onClick: cancelProductCheck,
                        children: "ยกเลิก"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "product-check-content",
                children: [
                    /*#__PURE__*/ _jsxs("aside", {
                        className: "product-check-sidebar",
                        children: [
                            /*#__PURE__*/ _jsxs("h3", {
                                children: [
                                    "รหัสใบจอง: ",
                                    session.reservation.rs_reserve_code
                                ]
                            }),
                            error ? /*#__PURE__*/ _jsx(Alert, {
                                variant: "danger",
                                children: error
                            }) : null,
                            /*#__PURE__*/ _jsx(Card, {
                                className: "p-3 mb-3",
                                children: /*#__PURE__*/ _jsxs(Form, {
                                    onSubmit: handleScan,
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Label, {
                                            className: "fw-bold text-primary",
                                            children: "กรุณาสแกนบาร์โค้ดสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            ref: scannerRef,
                                            disabled: busy,
                                            placeholder: "สแกนบาร์โค้ดที่นี่",
                                            onBlur: focusScanner,
                                            autoComplete: "off"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Card, {
                                className: "p-3 mb-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex align-items-center gap-2 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx(VideocamOutlinedIcon, {
                                                className: "text-primary"
                                            }),
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: "บันทึกวิดีโอการแพ็คสินค้า"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Badge, {
                                                bg: isDobybotConnected ? "success" : "secondary",
                                                children: socketStatus
                                            }),
                                            " ",
                                            /*#__PURE__*/ _jsx(Badge, {
                                                bg: "info",
                                                children: session.videoState
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex gap-2",
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                onClick: function() {
                                                    return sendVideoCommand("start");
                                                },
                                                disabled: busy || !isDobybotConnected || session.videoState === "RECORDING",
                                                children: "เริ่มถ่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "outline-primary",
                                                onClick: function() {
                                                    return sendVideoCommand("stop");
                                                },
                                                disabled: busy || !isDobybotConnected || session.videoState !== "RECORDING",
                                                children: "หยุดถ่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "outline-danger",
                                                onClick: function() {
                                                    return sendVideoCommand("cancel");
                                                },
                                                disabled: busy || !isDobybotConnected || session.videoState !== "RECORDING",
                                                children: "ยกเลิก"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Card, {
                                className: "p-3 text-center",
                                children: [
                                    /*#__PURE__*/ _jsx("h5", {
                                        children: "ความคืบหน้าในการสแกน"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "product-check-total ".concat(isComplete ? "complete" : ""),
                                        children: [
                                            totals.scanned,
                                            "/",
                                            totals.expected,
                                            " ชิ้น"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        size: "lg",
                                        className: "mt-3",
                                        disabled: busy || !isComplete || isDobybotConnected && session.videoState === "RECORDING",
                                        onClick: finish,
                                        children: "ตรวจนับเสร็จ"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("main", {
                        className: "product-check-table-wrap",
                        children: productItemGroups.map(function(group) {
                            return /*#__PURE__*/ _jsxs("section", {
                                className: "product-check-table-section",
                                children: [
                                    /*#__PURE__*/ _jsx("h5", {
                                        className: "product-check-table-title",
                                        children: group.title
                                    }),
                                    /*#__PURE__*/ _jsxs("table", {
                                        className: "product-check-table ".concat(group.tableClassName).trim(),
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "#"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "คิวอาร์โค้ด"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รูปสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ชื่อสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "บาร์โค้ด"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ขนาดบรรจุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "จำนวนสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "จัดการ"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("tbody", {
                                                children: [
                                                    group.items.map(function(item, index) {
                                                        return /*#__PURE__*/ _jsxs("tr", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: index + 1
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: qrCodes[item.product_check_item_detailid] ? /*#__PURE__*/ _jsx("img", {
                                                                        src: qrCodes[item.product_check_item_detailid],
                                                                        width: "76",
                                                                        height: "76",
                                                                        loading: "lazy",
                                                                        decoding: "async",
                                                                        alt: ""
                                                                    }) : "-"
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: item.image ? /*#__PURE__*/ _jsx("img", {
                                                                        className: "product-check-image",
                                                                        src: item.image,
                                                                        loading: "lazy",
                                                                        decoding: "async",
                                                                        alt: ""
                                                                    }) : "-"
                                                                }),
                                                                /*#__PURE__*/ _jsxs("td", {
                                                                    className: "text-start",
                                                                    children: [
                                                                        item.nameLao ? /*#__PURE__*/ _jsx("div", {
                                                                            children: item.nameLao
                                                                        }) : null,
                                                                        item.nameThai ? /*#__PURE__*/ _jsx("div", {
                                                                            children: item.nameThai
                                                                        }) : null,
                                                                        item.nameEnglish ? /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-secondary",
                                                                            children: item.nameEnglish
                                                                        }) : null,
                                                                        !item.nameLao && !item.nameThai && !item.nameEnglish ? /*#__PURE__*/ _jsx("div", {
                                                                            children: item.name
                                                                        }) : null,
                                                                        item.isFree ? /*#__PURE__*/ _jsx(Badge, {
                                                                            bg: "warning",
                                                                            text: "dark",
                                                                            className: "mt-1",
                                                                            children: "ของแถม"
                                                                        }) : null,
                                                                        item.isTester ? /*#__PURE__*/ _jsx(Badge, {
                                                                            bg: "info",
                                                                            text: "dark",
                                                                            className: "mt-1 ms-1",
                                                                            children: "สินค้าทดลอง"
                                                                        }) : null
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: item.product_check_item_barcode || "-"
                                                                }),
                                                                /*#__PURE__*/ _jsxs("td", {
                                                                    children: [
                                                                        item.unitName,
                                                                        " = ",
                                                                        item.unitRatio || 1,
                                                                        " ชิ้น",
                                                                        item.unitRatioOption ? " / ".concat(item.unitRatioOption, " แพ็ค") : ""
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("td", {
                                                                    children: [
                                                                        item.product_check_item_expectedqty,
                                                                        " ",
                                                                        item.unitName || "ชิ้น"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex justify-content-center align-items-center gap-2",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Button, {
                                                                                variant: "outline-primary",
                                                                                disabled: busy || item.product_check_item_scannedqty <= 0,
                                                                                onClick: function() {
                                                                                    return changeQuantity(item, -1);
                                                                                },
                                                                                children: "−"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "product-check-qty",
                                                                                children: item.product_check_item_scannedqty
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Button, {
                                                                                disabled: busy || item.product_check_item_scannedqty >= item.product_check_item_expectedqty,
                                                                                onClick: function() {
                                                                                    return changeQuantity(item, 1);
                                                                                },
                                                                                children: "+"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }, item.product_check_item_id);
                                                    }),
                                                    group.items.length === 0 ? /*#__PURE__*/ _jsx("tr", {
                                                        children: /*#__PURE__*/ _jsx("td", {
                                                            className: "product-check-empty",
                                                            colSpan: 8,
                                                            children: group.emptyMessage
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, group.key);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("style", {
                children: "\n        .product-check-page { height: calc(100vh - 70px); display:flex; flex-direction:column; background:#fff; }\n        .product-check-loader { position:fixed; inset:0; z-index:3000; display:flex; align-items:center; justify-content:center; opacity:0; visibility:hidden; pointer-events:none; background:rgba(255,255,255,.72); backdrop-filter:blur(0); cursor:wait; transition:opacity .2s ease, backdrop-filter .2s ease, visibility 0s linear .2s; }\n        .product-check-loader.show { opacity:1; visibility:visible; pointer-events:all; backdrop-filter:blur(3px); transition:opacity .2s ease, backdrop-filter .2s ease; }\n        .product-check-loader-panel { min-width:220px; padding:26px 30px; display:flex; flex-direction:column; align-items:center; gap:8px; color:#20376b; background:rgba(255,255,255,.96); border:1px solid rgba(32,55,107,.1); border-radius:16px; box-shadow:0 16px 48px rgba(32,55,107,.18); transform:translateY(8px) scale(.98); transition:transform .2s ease; }\n        .product-check-loader.show .product-check-loader-panel { transform:translateY(0) scale(1); }\n        .product-check-loader-panel .spinner-border { width:2.5rem; height:2.5rem; margin-bottom:4px; }\n        .product-check-loader-panel strong { font-size:18px; }\n        .product-check-loader-panel span { color:#6c757d; font-size:14px; }\n        @media (prefers-reduced-motion: reduce) { .product-check-loader, .product-check-loader-panel { transition:none; } }\n        .product-check-header { min-height:70px; padding:18px 24px; display:flex; justify-content:space-between; gap:12px; align-items:center; color:#20376b; font-size:24px; border-bottom:1px solid #e7eaf0; }\n        .product-check-content { min-height:0; flex:1; display:flex; }\n        .product-check-sidebar { width:360px; flex:0 0 360px; padding:24px; border-right:6px solid #17202d; overflow:auto; }\n        .product-check-sidebar h3 { font-size:22px; margin-bottom:20px; }\n        .product-check-table-wrap { min-width:0; flex:1; overflow:auto; padding-bottom:24px; }\n        .product-check-table-section + .product-check-table-section { margin-top:28px; }\n        .product-check-table-title { margin:0; padding:14px 16px; color:#20376b; font-size:18px; background:#fff; border-bottom:1px solid #e7e7e7; }\n        .product-check-table { width:100%; min-width:1050px; border-collapse:collapse; }\n        .product-check-table th { position:sticky; top:0; z-index:1; background:#f7ecec; padding:16px 12px; text-align:center; }\n        .product-check-table-completed th { background:#dff3e4; }\n        .product-check-table td { padding:14px 12px; border-bottom:1px solid #e7e7e7; text-align:center; vertical-align:middle; }\n        .product-check-table td.product-check-empty { padding:32px 12px; color:#6c757d; }\n        .product-check-image { width:74px; height:74px; object-fit:contain; }\n        .product-check-qty { display:inline-flex; width:58px; height:38px; align-items:center; justify-content:center; border:1px solid #dee2e6; border-radius:6px; }\n        .product-check-total { font-size:38px; font-weight:700; color:#dc3545; margin-top:8px; }\n        .product-check-total.complete { color:#198754; }\n        @media (max-width: 900px) {\n          .product-check-page { height:auto; min-height:100vh; }\n          .product-check-content { display:block; }\n          .product-check-sidebar { width:100%; border-right:0; border-bottom:6px solid #17202d; }\n          .product-check-table-wrap { max-height:65vh; }\n        }\n      "
            })
        ]
    });
}
